// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"39":"prices","177":"home","179":"main","311":"shoppingcart","486":"orders","626":"redirect","694":"cms"}[chunkId] + "." + {"39":"4891e835","177":"8c9ac861","179":"cfd4ab9d","311":"f81290c5","486":"5853c013","626":"569562e2","694":"ef80252e"}[chunkId] + ".css";
};